export const TRANSFER_LIST = 'TRANSFER_LIST';

export const listChange = change => ({
    type: TRANSFER_LIST,
    payload: change,
});